import { memo } from "react";

import { Chart } from "primereact/chart";
import ChartDataLabels from 'chartjs-plugin-datalabels';

export const GraficoProducaoReal = memo(function GraficoProducaoReal ({ chart }) {
    const options = {
        maintainAspectRatio: false, 
        plugins: {
            title: {
                display: true,
                text: `GRUPO ${chart.grupo} ${chart.periodo}`,
                font: {
                    size: 18
                }
            },
            datalabels: {
                labels: {
                    index: {
                        align: 'end',
                        anchor: 'end',
                        formatter: (value) => {
                            if(parseFloat(value)) {
                                return Intl.NumberFormat('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(value)
                            } else {
                                return ""
                            }
                        },
                        font: {
                            size: 20
                        },
                        color: "#2c3e50",
                        rotation: -90
                    },
                    turma: {
                        align: 'center',
                        anchor: 'center',
                        formatter: (value, context) => {
                            if(parseFloat(value)) {
                                return String(context.dataset.label).replace("Turma ", "");
                            } else {
                                return "";
                            }
                        },
                        font: {
                            size: 16
                        },
                        color: "#000",
                    },
                }
                
            }
        },
    }

    const LegendPlugin = {
        beforeInit(chart) {
            const fitValue = chart.legend.fit;
            chart.legend.fit = function () {
                fitValue.bind(chart.legend)();
                return this.height += 50;
            }
        }
    }

    return (
        <div>
            <h3 className="p-m-1">Grupo {chart.grupo}</h3>
            <Chart 
                data={chart.chartData}
                height="350px"
                options={options}
                plugins={[ChartDataLabels, LegendPlugin]}
                type="bar"
            /> 
        </div>
    )
})